export const ageMethod = "age nearest";
export const gateway = "https://atlasyork-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/atlasyork";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhdGxhc3lvcmsiLCJuYW1lIjoiYXRsYXN5b3JrIiwiaWF0IjoxNzc5OTIxODc0LCJleHAiOjE5Mzc3MDk4NzR9.l9Eo3mPsILhFnDNkw88l0yrddRvkkq2UgC1wJM7VRAw";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"atlasyork.link.wawanesalife.com": {
		a: {
			approve_company: "CENTRAL",
			approve_user: "link_atlas",
			brands: [
				"atlasyork.link.wawanesalife.com",
			],
			broker: "atlasyork",
			broker_formatted_name: "Atlas York Insurance",
			email: "service@atlasyork.ca",
			environment: "stable",
			environment_id: "stable",
			layout: "flat",
			logoPosition: "menu",
			"maps": {
				"map4": [
					"111 2nd Ave",
					"Dodsland",
					"SK",
					"S0L 0V0",
				],
				"map3": [
					"204 Main Street",
					"Coleville",
					"SK",
					"S0L 0K0",
				],
				"map2": [
					"219 Main Street",
					"Rosetown",
					"SK",
					"S0L 2V0",
				],
				"map1": [
					"3550 Taylor Street",
					"Saskatoon",
					"SK",
					"S7H 5H9",
				],
			},
			menuPhone: "button",
			phone: "306.986.0600",
			privacyLink: "https://atlasyork.ca/privacy-policy/",
			website: "https://atlasyork.ca/",
			scope: "atlasyork#branding#atlasyork.link.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "atlasyork.link.wawanesalife.com",
		},
		b: {
			approve_company: "CENTRAL",
			approve_user: "link_atlas",
			brands: [
				"atlasyork.link.wawanesalife.com",
			],
			broker: "atlasyork",
			broker_formatted_name: "Atlas York Insurance",
			email: "service@atlasyork.ca",
			environment: "stable",
			environment_id: "stable",
			layout: "flat",
			logoPosition: "menu",
			"maps": {
				"map4": [
					"111 2nd Ave",
					"Dodsland",
					"SK",
					"S0L 0V0",
				],
				"map3": [
					"204 Main Street",
					"Coleville",
					"SK",
					"S0L 0K0",
				],
				"map2": [
					"219 Main Street",
					"Rosetown",
					"SK",
					"S0L 2V0",
				],
				"map1": [
					"3550 Taylor Street",
					"Saskatoon",
					"SK",
					"S7H 5H9",
				],
			},
			menuPhone: "button",
			phone: "306.986.0600",
			privacyLink: "https://atlasyork.ca/privacy-policy/",
			website: "https://atlasyork.ca/",
			scope: "atlasyork#branding#atlasyork.link.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "atlasyork.link.wawanesalife.com",
		},
	},
};

//updated on Wed May 27 2026 17:44:34 GMT-0500 (Central Daylight Time)
